import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@services/apiClient';
import { whatsNewCountKey } from '@services/useWhatsNewCountQuery';

import { whatsNewListKey } from './useWhatsNewListInfiniteQuery';

const whatsNewMarkViewedAllFn = () =>
  apiClient.post(`${APP_API_URL_V2}customer-dashboard-v2/whats-new/set-viewed-all`);

export const useWhatsNewMarkViewedAllMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: whatsNewMarkViewedAllFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: whatsNewCountKey() });
      queryClient.invalidateQueries({ queryKey: [whatsNewListKey({})[0]] });
    },
  });
};
